import { MouseEvent } from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { PlusCircle as PlusIcon } from '../../../../icons/plus-circle';
import style from './style';

type Props = {
  title?: string,
  href?: string,
  type?: 'icon' | 'submit',
  disabled?: boolean,
  bgColor?: 'primary.main' | 'secondary.main',
  variant?: 'text' | 'outlined' | 'contained',
  icon?: JSX.Element,
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void,
}

const PerfectButton = ({
  title, disabled, onClick, href, icon, bgColor, variant, type,
}: Props): JSX.Element => {
  const button = () => {
    if (type === 'icon') {
      return (
        <IconButton
          onClick={ !href ? onClick : undefined }
          sx={ {
            borderRadius: '50%',
          } }
        >
          { icon }
        </IconButton>
      );
    }

    return (
      <Button
        disabled={ disabled }
        type={ type ?? 'button' }
        sx={ {
          ...style.sx,
          backgroundColor: variant === 'contained' ? bgColor : undefined,
        } }
        variant={ variant }
        size={ style.size }
        onClick={ !href ? onClick : undefined }
        startIcon={ icon }
      >
        { title }
      </Button>
    );
  };

  return href ? (
    <Link to={ href }>
      { button() }
    </Link>
  ) : (
    button()
  );
};

PerfectButton.defaultProps = {
  title: undefined,
  href: undefined,
  type: undefined,
  disabled: false,
  onClick: undefined,
  icon: <PlusIcon viewBox="1 1 18 18" />,
  bgColor: 'secondary.main',
  variant: 'contained',
};

export default PerfectButton;
